import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import {
  BUDGET_BASE_URL,
  DASHBOARD_URL,
  HOME_URL,
  SERVICE_REQUEST_BASE_URL
} from "@core/constants";
import { Observable, of } from "rxjs";
import { KeycloakHelperService } from "./keycloak.helper.service";
import { NavigationService } from "./navigation.service";

const TEMPORARY_REDIRECT_URL = "__redirect-service-request";

@Injectable({
  providedIn: "root"
})
export class RedirectService {
  constructor(
    private router: Router,
    private keycloakHelperService: KeycloakHelperService,
    private navigationService: NavigationService
  ) {}

  redirectToServiceRequest(): void {
    if (!this.router.url.startsWith(`/${SERVICE_REQUEST_BASE_URL}`)) {
      void this.router.navigateByUrl(SERVICE_REQUEST_BASE_URL);
      return;
    }

    // Necessary when the user is already on the service request url.
    // The user will be redirected to a neutral route and
    // then back to the service requests url.
    void this.router
      .navigateByUrl(TEMPORARY_REDIRECT_URL, {
        skipLocationChange: true
      })
      .then(() => this.router.navigateByUrl(SERVICE_REQUEST_BASE_URL));
  }

  redirectToCarworkshopContacts(carWorkshopId: number) {
    const url = `car-workshops/edit/${carWorkshopId}?scrollTo=contacts-id`;
    this.router.navigateByUrl(`${url}`);
  }

  getHomeUrl$(): Observable<string> {
    if (this.keycloakHelperService.isBackofficeExternalLogged()) {
      return of(SERVICE_REQUEST_BASE_URL);
    }

    if (this.keycloakHelperService.isCarWorkshopLogged()) {
      return of(DASHBOARD_URL);
    }

    return of(HOME_URL);
  }

  getServiceRequestUrl(): string {
    return SERVICE_REQUEST_BASE_URL;
  }

  getServiceRequestDetailsUrl(id: number): string {
    return `${SERVICE_REQUEST_BASE_URL}/${id}/details`;
  }

  getBudgetDetailsUrl(serviceReqId: number, budgetId: number): string {
    const url = this.getServiceRequestDetailsUrl(serviceReqId);
    return `${url}/${budgetId}/budget`;
  }

  getEvaluationBudgetCounterproposal(budgetId: number): string {
    return `${BUDGET_BASE_URL}/${budgetId}/evaluation-budget-counterproposal`;
  }

  getBackUrl(serviceReqId: number): string {
    const history = this.navigationService.getHistory();

    if (history.length === 1) {
      return this.getServiceRequestDetailsUrl(serviceReqId);
    }

    let backUrl = history[history.length - 2];
    backUrl = backUrl.startsWith("/") ? backUrl.substring(1) : backUrl;
    return backUrl;
  }
}
